import { useUiTheme } from 'framework/uiTheme';
import React from 'react';
import { BaseFieldLayoutType, LinkFieldLayoutProps, LinkFieldLayoutType } from '../../field';
import safeExternalHref from 'framework/utils/url/safeExternalHref';

const ExternalLinkFieldLayout: LinkFieldLayoutType = ({
  linkText,
  value,
  label,
  link,
  icon: Icon,
}: LinkFieldLayoutProps) => {
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const displayedValue = value ? (
    <a href={safeExternalHref(link || value)} target="_blank" rel="noopener noreferrer">
      {linkText}
      {Icon && <Icon sx={{ marginLeft: '7px', fontSize: '1.25rem', transform: 'translateY(-1px)' }} />}
    </a>
  ) : (
    '—'
  );

  return <BaseFieldLayout label={label} value={displayedValue} />;
};

export default ExternalLinkFieldLayout;
